import React, {Component} from 'react';

// Import custom components
import Title from './title.component';

class Emailnotices extends Component {

    render() {
        return (
            <div>
                <Title />

                <section>

                    {this.props.children}

                </section>

            </div>
        );
    }
}

export default Emailnotices;
